export function roundTwoDecimalPlaces(value: number): number {
    return Math.round(value * 100) / 100;
}

export function divideArrayIntoChunks(data: any[], chunkMaxLength: number) {
    const chunks = [];
    for (let i = 0; i < data.length; i += chunkMaxLength) {
        chunks.push(data.slice(i, i + chunkMaxLength));
    }
    return chunks;
}
